import React from 'react';
import {FaEnvelopeOpenText, FaProductHunt, FaRegWindowRestore,  FaWindowMaximize} from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';


const ImgExpansionPage = ({setNavLinks, imageUrl, folder, imgName, info}) => {

  return (

        <div className='container-fluid'>

              <div className="expansion-section">

                        <div 
                            className='close-window-icon' 
                            id="close-expansion"
                            data-tooltip-id='my-tooltip'
                            data-tooltip-content="Return"
                     
                        > 
                            <Tooltip id="my-tooltip"/>
                        
                            <FaRegWindowRestore color='#1b2328' onClick={()=>{

                                // returns to the same page the image is clicked from
                                return   folder==="Accessories" ? setNavLinks({hairAccessoriesLink: true}):
                                    folder==="OurHairs" ? setNavLinks({hairServicesLink: true}):
                                    folder==="crochets" ? setNavLinks({hairServicesLink2: true}):
                                    folder==="RevampStyling" ? setNavLinks({hairServicesLink3: true}):
                                    folder==="Weavons" ? setNavLinks({hairServicesLink1: true}):
                                    folder==="Braids" ? setNavLinks({hairServicesLink4: true}):
                                    folder==="eflyers" ? setNavLinks({graphicDesignLink: true}):
                                    folder==="logos" ? setNavLinks({graphicDesignLink1: true}):
                                    folder==="banAndLetter" ? setNavLinks({graphicDesignLink2: true}):
                                    folder==="brandAndId" ? setNavLinks({graphicDesignLink3: true}):
                                    folder==="VidLinks" ? setNavLinks({appWebDevLink: true}):null
                                
                                
                                
                                }}/>
                                
                          </div>
                      <h1 className='title'><FaWindowMaximize color='#1b2328' /> {imgName} </h1>
                   
          

            
            <div className='expanded-img-container'>
            
                <img  src={require(`../Images/ServiceImages/${folder}/${imageUrl}`)}  alt=""/>

            </div>

           <p className='contact-link' onClick={()=>setNavLinks({contactLink: true})}> Contact Us <FaEnvelopeOpenText/> </p>

            
             <div className='details-summary' style={info ? {display: "block" }: {display: "none"}}>
              
                  <h3 className='d-flex align-items-center gap-1 '> <FaProductHunt/> Products</h3>
                  {info}
              
              </div>



              </div>
          

                   
            

        </div>
  )
}

export default ImgExpansionPage;